/* ==========================================================================
   GOODS SCENE - SHOP BY BRAND, OVERFLOW CONTROLS
   --------------------------------------------------------------------------
   Progressive enhancement ONLY. The strip is a native horizontal scroller in
   CSS, so with this file blocked, failed or disabled the row still scrolls by
   swipe, trackpad and keyboard, and every tile is still a working link. This
   script adds two things and nothing else: it REVEALS the arrows (they ship
   with the `hidden` attribute) and it moves the strip when they are pressed.

   🔑 THE ARROWS ARE REVEALED, NEVER ASSUMED. Nothing here knows how many
   brands exist. It measures whether the track actually overflows, so a store
   that later drops to six brands shows no controls at all and a store that
   adds a twelfth needs no change.

   No library, no dependency, no autoplay, no dots, scoped to this component.
   ========================================================================== */

(function () {
  'use strict';

  /* How far one press travels. Three cards is enough to clear the overflow in
     one action at the current brand count while still landing on a full row of
     cards rather than three isolated ones. */
  var CARDS_PER_PRESS = 3;

  function reducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function init(root) {
    var track = root.querySelector('[data-gs-brand-track]');
    var prev = root.querySelector('[data-gs-brand-prev]');
    var next = root.querySelector('[data-gs-brand-next]');

    if (!track || !prev || !next) return;

    /* Measured from the DOM, not hard-coded: the card width is a calc() that
       changes at every breakpoint, so reading it back is the only way the step
       stays correct on a phone, a tablet and a desktop. */
    function step() {
      var card = track.querySelector('.gs-brand-card');
      if (!card) return track.clientWidth;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

      return (card.getBoundingClientRect().width + gap) * CARDS_PER_PRESS;
    }

    function update() {
      var overflow = track.scrollWidth - track.clientWidth;
      var scrollable = overflow > 1;

      prev.hidden = !scrollable;
      next.hidden = !scrollable;

      if (!scrollable) return;

      /* Disabled, not hidden, at the ends - so the controls do not appear and
         disappear as the strip moves. */
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= overflow - 1;
    }

    function go(direction) {
      track.scrollBy({
        left: direction * step(),
        behavior: reducedMotion() ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      go(-1);
    });

    next.addEventListener('click', function () {
      go(1);
    });

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      },
      { passive: true }
    );

    /* Re-measure when the track resizes: a breakpoint change alters both the
       card width and whether there is any overflow left to navigate. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }

    update();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gs-brand-row]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor rebuilds a section's DOM in place, which drops the
     listeners bound above. */
  document.addEventListener('shopify:section:load', boot);
})();